import React, { Component } from 'react';
import InputMask from 'react-input-mask';

import CadastroObservacao from './CadastroObservacao';
import UI from '../../../actions/ui-helper';
import API from '../../../actions/api-helper';

import StringUtil from '../../../actions/string';
import DataUtil from '../../../actions/data';

class CadastroUsuario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuario: this.getInitialState(),
      empresas: [],
    };
    if (this.props.match) {
      this.state.usuario.id = this.props.match.params.id;
    }

    this.getInitialState = this.getInitialState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeEmpresa = this.handleChangeEmpresa.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      empresa: { id: 0 },
      nome: '',
      cpf: '',
      sexo: 'M',
      dataNascimento: '',
      profissao: '',
      setor: '',
      telefoneCelular: '',
      telefoneComercial: '',
      email: '',
      perfil: 2,
      vinculo: 0,
      inativo: false,
      visivelRelatorio: true,
      observacao: '',
    };
  }

  // Hack para atualizar a pagina quando estiver nessa rota
  componentWillReceiveProps() {
    window.scrollTo(0, 0);
    let initial = this.getInitialState();
    initial.empresa.id = this.state.empresas.length > 0 ? this.state.empresas[0].id : 0;
    this.setState({ usuario: initial });
  }

  componentDidMount() {
    UI.inputHelpers();

    // Buscar empresas
    UI.loader('show', 'Um momento...');
    API.get('/empresas').then(
      function(json) {
        this.setState({ empresas: json.data });
        let usuario = { ...this.state.usuario };
        usuario.empresa.id = json.data[0].id;
        this.setState({ usuario: usuario });

        // Verifica se vem de uma rota com id
        let id = parseInt(this.state.usuario.id);
        if (id !== 0) {
          API.get('/usuarios/' + this.state.usuario.id)
            .then(
              function(json) {
                this.setState({ usuario: json.data });
                UI.loader('hide');
              }.bind(this),
            )
            .catch(function(json) {
              UI.loader('hide');
              UI.alert(false, json.message);
            });
        } else {
          UI.loader('hide');
        }
      }.bind(this),
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    let data = this.state.usuario;

    // Validação dos campos (temporario)
    if (data.nome === '') {
      UI.alert(false, 'O nome do usuário é obrigatório.');
      return false;
    }
    if (!StringUtil.validarCpf(data.cpf)) {
      UI.alert(false, 'Verifique o CPF informado.');
      return false;
    }
    if (!StringUtil.validarEmail(data.email)) {
      UI.alert(false, 'O email informado é invalido.');
      return false;
    }
    if (!DataUtil.validarData(data.dataNascimento)) {
      UI.alert(false, 'Verifique a data de nascimento.');
      return false;
    }

    // Preparar dados para envio
    data.cpf = StringUtil.unmask(data.cpf);
    data.telefoneCelular = StringUtil.unmask(data.telefoneCelular);
    data.telefoneComercial = StringUtil.unmask(data.telefoneComercial);

    // Chamada da API
    UI.loader('show', 'Um momento...');
    API.post('/usuarios', data)
      .then(
        function(json) {
          if (json.success) {
            this.props.onUpdate(json.data);
            this.setState({ usuario: json.data });
          }
          UI.alert(json.success, json.message);
          UI.loader('hide');
        }.bind(this),
      )
      .catch(function(json) {
        UI.alert(false, json.message);
        UI.loader('hide');
      });
  }

  handleChange(event) {
    let usuario = { ...this.state.usuario };
    usuario[event.target.name] = event.target.value;
    this.setState({ usuario: usuario });
  }

  handleChangeEmpresa(event) {
    let usuario = { ...this.state.usuario };
    usuario.empresa.id = event.target.value;
    this.setState({ usuario: usuario });
  }

  handleChecked(event) {
    let usuario = { ...this.state.usuario };
    usuario[event.target.name] = event.target.checked;
    this.setState({ usuario: usuario });
  }

  render() {
    var styleInativo = {
      background: '#eee',
      border: '1px solid #d00',
    };

    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div style={this.state.usuario.inativo ? styleInativo : null} className="card">
              <div className="card-body">
                <div className="form-group row">
                  <div className="col-md-12">
                    <h4 className="card-title">CADASTRO USUÁRIO</h4>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Nome Completo *</label>
                    <input
                      placeholder="NOME COMPLETO"
                      autoFocus
                      name="nome"
                      type="text"
                      className="form-control"
                      value={this.state.usuario.nome}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Sexo *</label>
                    <select
                      name="sexo"
                      className="form-control"
                      value={this.state.usuario.sexo}
                      onChange={this.handleChange}
                    >
                      <option value="M">MASCULINO</option>
                      <option value="F">FEMININO</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>CPF *</label>
                    <InputMask
                      placeholder="CPF"
                      name="cpf"
                      className="form-control"
                      mask="999.999.999-99"
                      value={this.state.usuario.cpf}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Email *</label>
                    <input
                      placeholder="EMAIL"
                      name="email"
                      className="form-control"
                      value={this.state.usuario.email}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Telefone Celular</label>
                    <InputMask
                      placeholder="TELEFONE CELULAR"
                      name="telefoneCelular"
                      className="form-control"
                      mask="(99) \99999-9999"
                      value={this.state.usuario.telefoneCelular}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Telefone Comercial</label>
                    <InputMask
                      placeholder="TELEFONE COMERCIAL"
                      name="telefoneComercial"
                      className="form-control"
                      mask="(99) 9999-9999"
                      value={this.state.usuario.telefoneComercial}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Data Nascimento *</label>
                    <InputMask
                      placeholder="DATA NASCIMENTO"
                      name="dataNascimento"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.usuario.dataNascimento}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Profissão</label>
                    <input
                      placeholder="PROFISSÃO"
                      name="profissao"
                      className="form-control"
                      value={this.state.usuario.profissao}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Setor</label>
                    <input
                      placeholder="SETOR"
                      name="setor"
                      className="form-control"
                      value={this.state.usuario.setor}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Perfil</label>
                    <select
                      name="perfil"
                      className="form-control"
                      value={this.state.usuario.perfil}
                      onChange={this.handleChange}
                    >
                      {this.props.usuario.perfil === 0 && <option value={0}>X-BRAIN</option>}
                      <option value={1}>ADMINISTRADOR</option>
                      <option value={2}>OPERADOR</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Empresa</label>
                    <select
                      disabled={this.props.usuario.perfil !== 0}
                      name="empresa"
                      className="form-control"
                      value={this.state.usuario.empresa.id}
                      onChange={this.handleChangeEmpresa}
                    >
                      {this.state.empresas.map(function(empresa, i) {
                        return (
                          <option key={empresa.id} value={empresa.id}>
                            {empresa.nomeFantasia}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Vínculo</label>
                    <select
                      name="vinculo"
                      className="form-control"
                      value={this.state.usuario.vinculo}
                      onChange={this.handleChange}
                    >
                      <option value={0}>INDEFINIDO</option>
                      <option value={1}>CLT</option>
                      <option value={2}>AUTÔNOMO</option>
                      <option value={3}>SÓCIO/PROPRIETÁRIO</option>
                      <option value={4}>ESTAGIÁRIO</option>
                      <option value={5}>PRESTADOR DE SERVIÇO</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label />
                    <div className="form-check form-check-primary">
                      <label className="form-check-label">
                        <input
                          name="visivelRelatorio"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.usuario.visivelRelatorio}
                          onChange={this.handleChecked}
                        />
                        Visível nos Relatórios
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <label />
                    <div className="form-check form-check-danger">
                      <label className="form-check-label">
                        <input
                          name="inativo"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.usuario.inativo}
                          onChange={this.handleChecked}
                        />
                        Inativo
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CadastroObservacao
          styleInativo={this.state.usuario.inativo ? styleInativo : null}
          observacoes={this.state.usuario.observacoes}
          onChange={this.handleChange}
        />
      </form>
    );
  }
}

export default CadastroUsuario;
